import React from "react";
import EnhancedAdminUsersTable from "../components/users/EnhancedAdminUsersTable";
import "../components/users/EnhancedAdminUsers.css";

/**
 * Admin User Page
 * - Enhanced user management with search, pagination, and WhatsApp features
 * - Lists all users with advanced filtering capabilities
 * - Provides detailed user management actions
 */
const AdminUserPage = () => {
 return (
 <div style={{ padding: "20px" }}>
 <div className="page-header">
 <h1>User Management</h1>
 <p>Manage registered users, view details, and send WhatsApp messages.</p>
 </div>
 <EnhancedAdminUsersTable />
 </div>
 );
};

export default AdminUserPage;
